var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('code-scanner',{attrs:{"identifier":_vm.$t('scanner.identifier.coin-card')},on:{"onDetected":_vm.detected}})}
var staticRenderFns = []

export { render, staticRenderFns }